import { api } from "./client.js";
export const authApi = {
    signInWithGoogle: (idToken) => api.post("api/auth/google", { json: { idToken } }).json(),
    logout: () => api.post("api/auth/logout").json(),
    me: () => api.get("api/me").json(),
};
